import React, {useState} from "react";
import {Outlet} from "react-router-dom";
import {Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink} from "reactstrap";
import styled from "styled-components";
import {Logo} from "../SharedComponents/Logo";
import {useAppVersion} from "../Utility/useAppVersion";

const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const VersionBadge = styled.span`
  font-size: 0.75rem;
  opacity: 0.7;
  color: #6b7280;
  font-weight: normal;
`;

export function NavigationMenu() {
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => setIsOpen(!isOpen);
    const version = useAppVersion();
    return <>
        <Navbar container={"fluid"} expand={"md"}>
            <NavbarBrand href="/">
                <BrandContainer>
                    <Logo size={32} />
                    <span>Factorio-Oh-No!</span>
                    <VersionBadge>{version}</VersionBadge>
                </BrandContainer>
            </NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
            <Nav navbar>
            <NavItem>
                <NavLink href={"/dashboard"}>Dashboard</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={"/mining"}>Mining</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={"/smelting"}>Smelting</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={"/production"}>Production</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={"/science"}>Science</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={"/assembly"}>Assembly</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={"/crafting"}>Crafting</NavLink>
            </NavItem>
            </Nav>
            </Collapse>
        </Navbar>
        <Outlet/>
    </>
}